'use client';
import { Image } from '@bw/elements';
import { AgencyDetails } from '@bw/external-apis/shared';
import { Asset } from 'contentful';
import { withoutThe } from '../../../../helpers/agencyUtils';
import { PeopleInOffice_inLogo } from '../../../../stock-images';
import { useAppContext } from '../../../form-stepper/StepperProvider';
import { ShortForm } from '../../short-form/ShortForm';
import styles from './AgencyTeamHeroSection.module.scss';

export interface AgencyTeamHeroSectionProps {
	agencyDetails: AgencyDetails;
	heroImage?: Asset<'WITHOUT_UNRESOLVABLE_LINKS'>;
}
type AnnouncementHeightProps = Record<string, string>;
export function AgencyTeamHeroSection({
	agencyDetails,
	heroImage,
}: AgencyTeamHeroSectionProps) {
	const { agency } = agencyDetails;
	const { announcementBannerHeight } = useAppContext();
	const announcementHeight: AnnouncementHeightProps = {
		'--announcement-banner-height': `${announcementBannerHeight}px`,
	};
	let agencySubtitle = '';

	const isJanickiAgency = agencyDetails.agency.storeNumber === '0378' || agencyDetails.agency.storeNumber === '0490';
	const isGlobalGreenAgency = agencyDetails.agency.storeNumber === '0825';

	if (isJanickiAgency) {
		agencySubtitle = ', part of The J&A Group,';
	} else if (isGlobalGreenAgency) {
		agencySubtitle = ', a GlobalGreen Insurance Agency entity now owned and operated by Brightway Insurance,';
	} else {
		agencySubtitle = '';
	}


	return (
		<section className={styles.AgencyHeroImageFormSection}>
			<div className="container container--max">
				<div
					className={`${styles.AgencyHeroimageColTextForm} ${styles['AgencyHeroimageColTextForm--imageWithFormHeading']}`}
					style={announcementHeight}
				>
					<figure className={styles.imageSection} data-aos="fade-up">
						<Image
							alt="agency team hero image"
							src={heroImage?.fields?.file?.url ?? PeopleInOffice_inLogo}
							width={heroImage?.fields?.file?.details?.image?.width || 1500}
							height={heroImage?.fields?.file?.details?.image?.height || 1000}
							sizes="(max-width: 1149px) 100vw, 40vw"
						/>
					</figure>
					<article className={styles.textSection}>
						<h1 data-aos="fade-up">
							Meet Your {withoutThe(agency.marketingName)} Brightway Insurance
							Team
						</h1>
						<p data-aos="fade-up">
							The key to exceptional insurance coverage starts with an agent who
							truly understands your needs. Our{' '}
							{withoutThe(agency.marketingName)} team{agencySubtitle} lives
							right here in the community. We know the unique risks, assets, and
							lifestyles of {agencyDetails.intro.city || agency.city} residents.
						</p>
						<span className={styles.formTagline} data-aos="fade-up">
							Let&apos;s talk.
						</span>
						<ShortForm agencyDetails={agencyDetails} />
					</article>
				</div>
			</div>
		</section>
	);
}
